var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoPhotos = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 98,
  height: 99,
  fill: "none",
  viewBox: "0 0 98 99"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M29.923 58.07 10.976 82.636h76.048L62.589 49.969 43.643 74.404zM98 87.993q0 4.443-3.267 7.71-3.266 3.266-7.709 3.266H10.976q-4.443 0-7.71-3.267Q0 92.436 0 87.993V11.945q0-4.443 3.267-7.71Q6.533.97 10.976.97h76.048q4.443 0 7.71 3.267Q98 7.502 98 11.945z",
  clipRule: "evenodd"
})));
export default SvgNoPhotos;